import { useState, useEffect, useCallback } from "react";
import { useHttpClient } from "../../../../../shared/hooks/http-hook";

import moment from "moment";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

import MultiSelect from "../../../fluxoCaixa/components/filtros/MultiSelect";
import "../../../fluxoCaixa/components/filtros/ModalFiltros.scss";

function ModalFiltrosReceitas({
  openModalFiltros,
  handleCloseModalFiltros,
  handleFiltrar,
  entradas,
  parcelas,
  filtrosAplicados,
  filtroCaixa,
  filtroCategoria,
  filtroMetodoPagamento,
  clinicaId,
  auth,
}) {
  const [openModal, setOpenModal] = useState(false);
  /* Caixa, categoria e método são de escolha MÚLTIPLA: lista vazia = todos.
     Mesma convenção do `MultiSelect` e do «Recebido por», que já era múltiplo.
     O `Array.isArray` protege de filtragens guardadas em texto de uma versão
     anterior — sem ele, o `.includes` passava a comparar letras. */
  const comoLista = (valor) => (Array.isArray(valor) ? valor : []);

  const [categoria, setCategoria] = useState(comoLista(filtroCategoria));
  const [categorias, setCategorias] = useState([]);
  const [caixa, setCaixa] = useState(comoLista(filtroCaixa));
  const [caixas, setCaixas] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const [radioPagas, setRadioPagas] = useState(
    filtrosAplicados.includes("pagas") ? true : false,
  );
  const [radioNPagas, setRadioNPagas] = useState(
    filtrosAplicados.includes("naoPagas") ? true : false,
  );

  const [emAtraso, setEmAtraso] = useState(
    filtrosAplicados.includes("emAtraso") ? true : false,
  );

  const [showEmAtraso, setShowEmAtraso] = useState(
    !filtrosAplicados.includes("pagas") ? true : false,
  );

  const [emitido, setEmitido] = useState(
    filtrosAplicados.includes("emitido") ? true : false,
  );

  const [showComComprovante, setShowComComprovante] = useState(
    !filtrosAplicados.includes("naoPagas") ? true : false,
  );

  const [radioEntradas, setRadioEntradas] = useState(
    filtrosAplicados.includes("entradas") ? true : false,
  );

  const [radioParcelas, setRadioParcelas] = useState(
    filtrosAplicados.includes("parcelas") ? true : false,
  );

  const { sendRequest } = useHttpClient();

  const formasPagamento = [
    "Todos",
    "Dinheiro",
    "Cheque",
    "Internet banking",
    "Cartão de crédito",
  ];

  const [metodoPagamento, setMetodoPagamento] = useState(
    comoLista(filtroMetodoPagamento),
  );

  /** Lista vazia não filtra; com valores, o registo tem de ser um deles. */
  const corresponde = (selecionados, valor) =>
    selecionados.length === 0 || selecionados.includes(valor);

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/entrada/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setCategorias(
          responseData.categoriasFinanceiro.map((cat) => {
            return { id: cat.id, value: cat.categoria };
          }),
        );
      } catch (err) {
        console.error("err", err);
      }
    };

    const fetchCaixas = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinicaId}?todas=true`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        setCaixas(
          responseData.caixas.map((cai) => {
            return { id: cai.id, value: cai.caixa };
          }),
        );
      } catch (err) {
        console.error("err", err);
      }
    };

    const fetchUsers = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/users/ativos/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setUsers(
          responseData.users.map((u) => {
            return { id: u.id, value: u.name };
          }),
        );
      } catch (err) {
        console.error("err", err);
      }
    };

    fetchUsers();
    fetchCaixas();
    fetchCategorias();
  }, [auth.token, clinicaId, sendRequest]);

  useEffect(() => {
    setOpenModal(openModalFiltros);
  }, [openModalFiltros]);

  const metodoPagamentoChangeHandler = useCallback((valor) => {
    setMetodoPagamento(valor);
  }, []);

  const handlePagasChange = useCallback((e) => {
    setRadioPagas(e.target.checked);
    setRadioNPagas(!e.target.checked);
    setEmAtraso(false);
    setShowEmAtraso(false);
    setShowComComprovante(true);
  }, []);

  const handleNPagasChange = useCallback((e) => {
    setRadioNPagas(e.target.checked);
    setRadioPagas(!e.target.checked);
    setShowEmAtraso(true);
    setShowComComprovante(false);
    setEmitido(false);
  }, []);

  const filtrarModalHandler = useCallback(() => {
    /* Calculado AQUI DENTRO, e não no corpo do componente: fora, ficava
       capturado no render em que este `useCallback` foi criado, e uma escolha
       feita depois não contava. Dentro, é sempre o valor do momento em que se
       carrega em «Filtrar».

       Preserva um comportamento que já existia e não é óbvio: SEM filtros de
       caixa, categoria e método, as parcelas e entradas POR RECEBER também
       entram; com qualquer um deles, só as recebidas — uma parcela por receber
       não tem caixa nem método, logo não corresponderia a nada. */
    const semFiltroDeLinha =
      caixa.length === 0 &&
      categoria.length === 0 &&
      metodoPagamento.length === 0;

    //Contas Correntes///////////////////////////////////////
    let parcelasFiltradas = [];
    if (radioParcelas || (!radioEntradas && !radioParcelas)) {
      parcelasFiltradas = parcelas.filter((parcela) => {
        if (
          selectedUsers.length > 0 &&
          !selectedUsers.includes(parcela.recebidoPor?.user?._id)
        )
          return false;

        if (
          (parcela.parcelaPaga && radioPagas && parcela.quantiaPaga > 0) ||
          (!parcela.parcelaPaga && radioNPagas) ||
          (!radioPagas && !radioNPagas)
        ) {
          if (
            (!parcela.parcelaPaga &&
              emAtraso &&
              moment(parcela.dataLimitePagamento).isBefore(moment(), "day")) ||
            (!emAtraso &&
              !parcela.parcelaPaga &&
              !moment(parcela.dataLimitePagamento).isBefore(moment(), "day")) ||
            (parcela.parcelaPaga && !emAtraso) ||
            (!parcela.parcelaPaga && !emAtraso)
          ) {
            if (
              (parcela.parcelaPaga &&
                corresponde(caixa, parcela.caixa?._id) &&
                corresponde(metodoPagamento, parcela.metodoPagamento)) ||
              semFiltroDeLinha
            ) {
              if (
                (parcela.documentoEletronico?.succeeded === true && emitido) ||
                !emitido
              ) {
                return true;
              }
            }
          }
        }
        return false;
      });
    }

    //////////////////////////////////////
    //Entradas////////////////////////////
    let entradasFiltradas = [];
    if (radioEntradas || (!radioEntradas && !radioParcelas)) {
      entradas.forEach((entrada) => {
        if (
          selectedUsers.length > 0 &&
          !selectedUsers.includes(entrada.recebidoPor?.user?._id)
        )
          return;

        if (
          (entrada.entradaRecebida && radioPagas) ||
          (!entrada.entradaRecebida && radioNPagas) ||
          (!radioPagas && !radioNPagas)
        ) {
          if (
            (!entrada.entradaRecebida &&
              emAtraso &&
              moment(entrada.dataLimitePagamento).isBefore(moment(), "day")) ||
            (!emAtraso &&
              !entrada.entradaRecebida &&
              !moment(entrada.dataLimitePagamento).isBefore(moment(), "day")) ||
            (entrada.entradaRecebida && !emAtraso) ||
            (!entrada.entradaRecebida && !emAtraso)
          ) {
            if (
              (entrada.entradaRecebida &&
                corresponde(caixa, entrada.caixa?._id) &&
                corresponde(metodoPagamento, entrada.metodoPagamento) &&
                corresponde(categoria, entrada.categoria?._id)) ||
              semFiltroDeLinha
            ) {
              if (
                (entrada.documentoEletronico?.succeeded === true && emitido) ||
                !emitido
              )
                entradasFiltradas.push({ ...entrada });
            }
          }
        }
      });
    } else {
      entradasFiltradas = [];
    }

    const filtrosApli = [];
    radioPagas && filtrosApli.push("pagas");
    radioNPagas && filtrosApli.push("naoPagas");
    emAtraso && filtrosApli.push("emAtraso");
    emitido && filtrosApli.push("emitido");
    emAtraso && filtrosApli.push("emAtraso");
    radioEntradas && filtrosApli.push("entradas");
    radioParcelas && filtrosApli.push("parcelas");

    handleFiltrar(
      parcelasFiltradas,
      entradasFiltradas,
      filtrosApli,
      caixa,
      categoria,
      metodoPagamento,
      "",
      "modalFiltros",
    );
    handleCloseModalFiltros();
  }, [
    radioPagas,
    radioNPagas,
    emAtraso,
    emitido,
    radioEntradas,
    radioParcelas,
    caixa,
    categoria,
    metodoPagamento,
    selectedUsers,
    parcelas,
    entradas,
    handleFiltrar,
    handleCloseModalFiltros,
  ]);

  const resetModalHandler = useCallback(() => {
    setSelectedUsers([]);
    /* Estes três não estavam a ser repostos: o filtro era limpo mas os campos
       do modal continuavam a mostrar a escolha anterior, e ao reabrir parecia
       que ainda estava aplicada. */
    setCaixa([]);
    setCategoria([]);
    setMetodoPagamento([]);
    handleFiltrar(parcelas, entradas, [], null, null, null, "", "modalFiltros");
    handleCloseModalFiltros();
  }, [parcelas, entradas, handleFiltrar, handleCloseModalFiltros]);

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModalFiltros}
      aria-labelledby="modal-filtros-title"
      aria-describedby="modal-filtros-description"
    >
      <Box className="financeiro__modalFiltros__filtros-modal-box">
        <div className="financeiro__modalFiltros__modal-container">
          {/* Header */}
          <div className="financeiro__modalFiltros__modal-header">
            <div className="financeiro__modalFiltros__modal-title">
              <span className="financeiro__modalFiltros__filter-icon">🔍</span>
              <h2 id="modal-filtros-title">Filtrar por</h2>
            </div>
            <div className="financeiro__modalFiltros__header-actions">
              <button
                className="financeiro__modalFiltros__reset-btn"
                onClick={resetModalHandler}
              >
                ↻ Resetar
              </button>
              <button
                className="financeiro__modalFiltros__close-btn"
                onClick={handleCloseModalFiltros}
              >
                ×
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="financeiro__modalFiltros__modal-content">
            <div className="financeiro__modalFiltros__filters-section">
              {/* Tipos de Movimento */}
              <div className="financeiro__modalFiltros__filter-group">
                <h3 className="financeiro__modalFiltros__group-title">
                  Tipos de Movimento
                </h3>
                <div className="financeiro__modalFiltros__checkbox-grid financeiro__modalFiltros__two-cols">
                  <label
                    className={`financeiro__modalFiltros__checkbox-card ${
                      radioParcelas ? "financeiro__modalFiltros__active" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={radioParcelas}
                      onChange={(e) => setRadioParcelas(e.target.checked)}
                    />
                    <div className="financeiro__modalFiltros__checkbox-content">
                      <div className="financeiro__modalFiltros__label-text">
                        Parcelas
                      </div>
                      <div className="financeiro__modalFiltros__desc-text">
                        Pagamentos de orçamentos
                      </div>
                    </div>
                  </label>

                  {auth.perm.includes("r-ent") && (
                    <label
                      className={`financeiro__modalFiltros__checkbox-card ${
                        radioEntradas ? "financeiro__modalFiltros__active" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={radioEntradas}
                        onChange={(e) => setRadioEntradas(e.target.checked)}
                      />
                      <div className="financeiro__modalFiltros__checkbox-content">
                        <div className="financeiro__modalFiltros__label-text">
                          Entradas
                        </div>
                        <div className="financeiro__modalFiltros__desc-text">
                          Receitas diversas
                        </div>
                      </div>
                    </label>
                  )}
                </div>
              </div>

              {/* Status de Pagamento */}
              <div className="financeiro__modalFiltros__filter-group">
                <h3 className="financeiro__modalFiltros__group-title">
                  Estado de Pagamento
                </h3>
                <div className="financeiro__modalFiltros__checkbox-grid financeiro__modalFiltros__two-cols">
                  <label
                    className={`financeiro__modalFiltros__checkbox-card ${
                      radioPagas ? "financeiro__modalFiltros__active" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="estadoRadios"
                      checked={radioPagas}
                      onChange={handlePagasChange}
                    />
                    <div className="financeiro__modalFiltros__checkbox-content">
                      <div className="financeiro__modalFiltros__label-text">
                        Pagas
                      </div>
                      <div className="financeiro__modalFiltros__desc-text">
                        Receitas já recebidas
                      </div>
                    </div>
                  </label>

                  <label
                    className={`financeiro__modalFiltros__checkbox-card ${
                      radioNPagas ? "financeiro__modalFiltros__active" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="estadoRadios"
                      checked={radioNPagas}
                      onChange={handleNPagasChange}
                    />
                    <div className="financeiro__modalFiltros__checkbox-content">
                      <div className="financeiro__modalFiltros__label-text">
                        Não Pagas
                      </div>
                      <div className="financeiro__modalFiltros__desc-text">
                        Receitas a receber
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              {/* Filtros Adicionais */}
              <div className="financeiro__modalFiltros__filter-group">
                <h3 className="financeiro__modalFiltros__group-title">
                  Filtros Adicionais
                </h3>
                <div className="financeiro__modalFiltros__checkbox-grid financeiro__modalFiltros__two-cols">
                  {showComComprovante && (
                    <label
                      className={`financeiro__modalFiltros__checkbox-card ${
                        emitido ? "financeiro__modalFiltros__active" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={emitido}
                        onChange={(e) => setEmitido(e.target.checked)}
                      />
                      <div className="financeiro__modalFiltros__checkbox-content">
                        <div className="financeiro__modalFiltros__label-text">
                          Emitidos
                        </div>
                        <div className="financeiro__modalFiltros__desc-text">
                          Com comprovante eletrônico
                        </div>
                      </div>
                    </label>
                  )}

                  {showEmAtraso && (
                    <label
                      className={`financeiro__modalFiltros__checkbox-card ${
                        emAtraso ? "financeiro__modalFiltros__active" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={emAtraso}
                        onChange={(e) => setEmAtraso(e.target.checked)}
                      />
                      <div className="financeiro__modalFiltros__checkbox-content">
                        <div className="financeiro__modalFiltros__label-text">
                          Em Atraso
                        </div>
                        <div className="financeiro__modalFiltros__desc-text">
                          Vencidos e não pagos
                        </div>
                      </div>
                    </label>
                  )}
                </div>
              </div>

              {/* Recebido por - Sempre visível */}
              {users && (
                <div className="financeiro__modalFiltros__selects-grid">
                  <div className="financeiro__modalFiltros__select-field">
                    <label className="financeiro__modalFiltros__select-label">
                      Recebido por
                    </label>
                    <MultiSelect
                      options={users}
                      selectedIds={selectedUsers}
                      onChange={setSelectedUsers}
                      placeholder="Todos"
                    />
                  </div>
                </div>
              )}

              {/* Selects - Só aparecem quando "Pagas" está selecionado */}
              {radioPagas && (
                <div className="financeiro__modalFiltros__selects-grid">
                  {/* Caixa */}
                  {caixas && (
                    <div className="financeiro__modalFiltros__select-field">
                      <label className="financeiro__modalFiltros__select-label">
                        Caixa
                      </label>
                      <MultiSelect
                        options={caixas}
                        selectedIds={caixa}
                        onChange={setCaixa}
                        placeholder="Todas"
                      />
                    </div>
                  )}

                  {/* Método de Pagamento */}
                  <div className="financeiro__modalFiltros__select-field">
                    <label className="financeiro__modalFiltros__select-label">
                      Método de pagamento
                    </label>
                    {/* O «Todos» sai da lista: aqui é a ausência de escolha, e
                        não mais uma opção a par das outras. */}
                    <MultiSelect
                      options={formasPagamento
                        .filter((f) => f !== "Todos")
                        .map((f) => ({ id: f, value: f }))}
                      selectedIds={metodoPagamento}
                      onChange={metodoPagamentoChangeHandler}
                      placeholder="Todos"
                    />
                  </div>

                  {/* Categoria - Só mostra para Entradas */}
                  {categorias && radioEntradas && (
                    <div className="financeiro__modalFiltros__select-field">
                      <label className="financeiro__modalFiltros__select-label">
                        Categoria
                        <span className="financeiro__modalFiltros__subtitle">
                          (só entradas)
                        </span>
                      </label>
                      <MultiSelect
                        options={categorias}
                        selectedIds={categoria}
                        onChange={setCategoria}
                        placeholder="Todas"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Footer */}
          <div className="financeiro__modalFiltros__modal-footer">
            <button
              className="financeiro__modalFiltros__cancel-btn"
              onClick={handleCloseModalFiltros}
            >
              Fechar
            </button>
            <button
              className="financeiro__modalFiltros__apply-btn"
              onClick={filtrarModalHandler}
            >
              Filtrar
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ModalFiltrosReceitas;
